import React from 'react';

import { AsyncBoundaryComponent } from 'utils/asyncBoundary/asyncBoundaryComponents';
import { SidebarModalWindowComponent } from 'design/sidebarModal';
import { ModalLayerComponent } from 'design/modalLayer';
import { PartnerClientManagerContent } from './PartnerClientManagerContent';
import { useAppDispatcher } from 'hooks/useAppDispatcher';
import { useAppState } from 'hooks/useAppState';
import { FadeAnimationComponent } from 'design/fadeAnimationComponents';

export const PartnerClientManager = () => {
  const dispatch = useAppDispatcher();

  const { partnerClientManager } = useAppState();

  const close = React.useCallback(() => {
    dispatch({
      name: 'PartnerClientManager__Closed',
    });
  }, [dispatch]);

  if (partnerClientManager.opened) {
    return (
      <ModalLayerComponent theme="transparent">
        <SidebarModalWindowComponent
          size="l"
          onClose={close}
          onMisclick={close}
          onEscape={close}
        >
          <AsyncBoundaryComponent fallback={null}>
            <FadeAnimationComponent trigger={partnerClientManager.clientId}>
              <PartnerClientManagerContent />
            </FadeAnimationComponent>
          </AsyncBoundaryComponent>
        </SidebarModalWindowComponent>
      </ModalLayerComponent>
    );
  }

  return null;
};
